/* Betriebsart-Vokabular: bestimmt, ob die Oberfläche von Kunden, Patienten oder Gästen
   spricht. Reine Anzeige-Ebene — Tabelle `clients`, `client_id` und alle API-Felder
   heißen unabhängig davon weiterhin so.

   Kunde, Patient und Gast sind alle maskulin, der Artikel bleibt also überall "der".
   Vollständige Wortformen sind trotzdem nötig: Kunde und Patient werden schwach gebeugt
   ("den Kunden", "den Patienten"), Gast dagegen stark ("den Gast"). Und die Komposita
   bilden sich unterschiedlich — Kundendaten, Patientendaten, aber Gästedaten. */

export const DEFAULT_TERMINOLOGY = "clients";

const BASE_VOCABULARIES = {
  clients: {
    id: "clients",
    label: "Kunden",
    hint: "Salon, Studio, Barbershop",
    person: { sg: "Kunde", acc: "Kunden", pl: "Kunden", prefix: "Kunden" },
    service: { sg: "Leistung", pl: "Leistungen", prefix: "Leistungs" },
    journey: "Kundenführung",
    venue: "Studio",
  },
  patients: {
    id: "patients",
    label: "Patienten",
    hint: "Praxis, Heilpraktiker, Physiotherapie",
    person: { sg: "Patient", acc: "Patienten", pl: "Patienten", prefix: "Patienten" },
    service: { sg: "Behandlung", pl: "Behandlungen", prefix: "Behandlungs" },
    journey: "Patientenführung",
    venue: "Praxis",
  },
  guests: {
    id: "guests",
    label: "Gäste",
    hint: "Spa, Wellness, Kosmetik",
    person: { sg: "Gast", acc: "Gast", pl: "Gäste", prefix: "Gäste" },
    service: { sg: "Anwendung", pl: "Anwendungen", prefix: "Anwendungs" },
    /* Nicht "Gästeführung" - das waere eine Stadtführung. Deshalb steht der
       Begriff ausgeschrieben, statt aus person.prefix gebaut zu werden. */
    journey: "Gästebetreuung",
    venue: "Spa",
  },
};

/* Personal heißt in allen Sets gleich. Bewusst so entschieden — "Behandler" wäre für
   Praxen zwar korrekt, aber Praxen beschäftigen auch Empfang und Verwaltung. */
const STAFF = { sg: "Mitarbeiter", pl: "Mitarbeiter" };

function buildVocabulary(base) {
  const { person, service } = base;
  return {
    ...base,
    staff: STAFF,
    /* Für den langen Schwanz an Komposita: personWord("historie") -> "Kundenhistorie" */
    personWord: (suffix) => `${person.prefix}${suffix}`,
    serviceWord: (suffix) => `${service.prefix}${suffix}`,
    /* Die häufigsten Komposita ausgeschrieben, damit Aufrufstellen lesbar bleiben. */
    personData: `${person.prefix}daten`,
    personList: `${person.prefix}liste`,
    personFile: `${person.prefix}akte`,
    personArea: `${person.prefix}bereich`,
    personProfile: `${person.prefix}profil`,
    personName: `${person.prefix}name`,
  };
}

export const VOCABULARIES = Object.fromEntries(
  Object.entries(BASE_VOCABULARIES).map(([id, base]) => [id, buildVocabulary(base)])
);

export const TERMINOLOGY_OPTIONS = Object.values(VOCABULARIES).map(({ id, label, hint }) => ({
  id,
  label,
  hint,
}));

export function getVocabulary(terminology) {
  return VOCABULARIES[String(terminology || "").trim()] || VOCABULARIES[DEFAULT_TERMINOLOGY];
}
